const buildAnswersObject = (data, isStoreFeedback, store) => {
  const answersObj = {};
  data.questions.forEach((q) => {
    answersObj[q.questionId] = {
      value: q.type === 'STAR' ? 0 : q.type === 'STORE' && isStoreFeedback ? store.identifier : '',
      // valid = true by default. Validation should handle the rest
      // will set to false if:
      // 1) empty, required and submitted
      // 2) focused and unfocused if empty and required,
      valid: true,
      followupAnswer: q.followupAnswer,
      id: q.questionId,
      required: q.required,
      errorMsg: undefined,
      name: q.type.toLowerCase(),
    };
    if (q.followupQuestions && q.followupQuestions.length > 0) {
      q.followupQuestions.forEach((fq) => {
        answersObj[fq.questionId] = {
          parentId: q.questionId,
          value: '',
          valid: true,
          id: fq.questionId,
          required: fq.required,
          errorMsg: undefined,
          name: fq.type.toLowerCase(),
        };
      });
    }
  });

  return answersObj;
};

export { buildAnswersObject };
